import gql from 'graphql-tag'

export const SEARCH_RANKING_FACTOR_WEIGHTS_QUERY = gql`
  query SearchRankingFactorWeights {
    searchRankingFactorWeights {
      distance
      freshness
      type
      touring
      utilization
    }
  }
`
